import { TextKey } from '@mews-distributor/common';

export const monthNameKeys: Mews.TextKey[] = [
    TextKey.MonthJanuary,
    TextKey.MonthFebruary,
    TextKey.MonthMarch,
    TextKey.MonthApril,
    TextKey.MonthMay,
    TextKey.MonthJune,
    TextKey.MonthJuly,
    TextKey.MonthAugust,
    TextKey.MonthSeptember,
    TextKey.MonthOctober,
    TextKey.MonthNovember,
    TextKey.MonthDecember,
];

export const monthShortNameKeys: Mews.TextKey[] = [
    TextKey.MonthShortJanuary,
    TextKey.MonthShortFebruary,
    TextKey.MonthShortMarch,
    TextKey.MonthShortApril,
    TextKey.MonthShortMay,
    TextKey.MonthShortJune,
    TextKey.MonthShortJuly,
    TextKey.MonthShortAugust,
    TextKey.MonthShortSeptember,
    TextKey.MonthShortOctober,
    TextKey.MonthShortNovember,
    TextKey.MonthShortDecember,
];

export const dayNameKeys: Mews.TextKey[] = [
    TextKey.DaySunday,
    TextKey.DayMonday,
    TextKey.DayTuesday,
    TextKey.DayWednesday,
    TextKey.DayThursday,
    TextKey.DayFriday,
    TextKey.DaySaturday,
];

export const dayShortNameKeys: Mews.TextKey[] = [
    TextKey.DayShortSunday,
    TextKey.DayShortMonday,
    TextKey.DayShortTuesday,
    TextKey.DayShortWednesday,
    TextKey.DayShortThursday,
    TextKey.DayShortFriday,
    TextKey.DayShortSaturday,
];
